<template>
  <Notification :description="$t('rc_disconnected_alternative_notification')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="openUpdateConnectivityProviderModal"
        >
          <span>{{ $t('rc_upgrade_cta') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'
import Notification from '@/components/productNotifications/Notification.vue'

import { useRateConnect } from '@/components/rateConnect/useRateConnect'

const { openUpdateConnectivityProviderModal } = useRateConnect()
</script>
